import React from "react";
import { kebabCase } from "lodash";
import { Link } from "gatsby";
import styles from "./style.module.scss";

const Taglist = tags => {
  return (
    <div style={{ marginTop: `4rem` }}>
      <h4>Tags</h4>
      <div className={styles.taglist}>
        {tags.tags.map(tag => (
          <div key={tag + `tag`}>
            <Link to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Taglist;
